module.exports = __webpack_public_path__ + "fdad1fb5d8f89eaa0aa47cbc0f066367.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/monsters/monster-6.png
// module id = 1658
// module chunks = 0